import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { GetRaqResultByOrganization } from '../../../../../store/HR/Raqeeb/raqeebSlice';
import ChartAnalysis from './ChartAnalysis';

// import AnalysisTable from './AnalysisTable';

const AttendanceCharts = () => {
  const [results, setResults] = useState([]); // حالة محلية لتخزين النتائج
  const [loading, setLoading] = useState(false); // حالة لتحميل البيانات
  // const [error, setError] = useState(null); // حالة لتخزين الأخطاء

  const [dateRange, setDateRange] = useState({
    fromDate: '',
    toDate: '',
  });

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleGetResult = async () => {
    setLoading(true);
    // setError(null);
    try {
      const result = await dispatch(
        GetRaqResultByOrganization({
          DateFrom: dateRange.fromDate,
          DateTo: dateRange.toDate,
        })
      ).unwrap(); // unwrap إذا كنت تستخدم Redux Toolkit
      debugger;
      if (result?.succeeded) {
        setResults(result.data); // تخزين النتيجة
      } else {
        // setError(result.message || 'Something went wrong');
      }
    } catch (err) {
      // setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="row bg-inverse bg-opacity-10 p-2 rounded-2 mb-3">
        <div className="col-xl-3">
          <div className="input-group mb-3 ">
            <span className="input-group-text">{t('From')}</span>

            <input
              type="date"
              className="form-control text-center"
              value={dateRange.fromDate}
              onChange={(e) => setDateRange({ ...dateRange, fromDate: e.target.value })}
            />
          </div>
        </div>
        <div className="col-xl-3">
          <div className="input-group mb-3">
            <span className="input-group-text">{t('To')}</span>
            <input
              type="date"
              className="form-control text-center"
              value={dateRange.toDate}
              onChange={(e) => setDateRange({ ...dateRange, toDate: e.target.value })}
            />
          </div>
        </div>

        <div className="col-xl-3 text-start">
          <button
            type="button"
            className="btn btn-outline-theme w-100"
            onClick={handleGetResult}
            disabled={loading}>
            {loading ? (
              <div className="spinner-border spinner-border-sm me-2"></div>
            ) : (
              <i className="fas fa-calendar-alt fa-lg fa-fw me-2 "></i>
            )}
            {t('Show')}
          </button>
        </div>
      </div>

      {/* {results.length > 0 && <AnalysisTable ResultList={results} />} */}
      <div className="row">
        <ChartAnalysis data={results} />
      </div>
    </>
  );
};

export default AttendanceCharts;
